export default __webpack_public_path__ + "static/footer-bg-3b070af01f947f0349dc14fb4639f987.png";